export default {
  name: 'Living Room',
  id: 'Livingroom',
  data: [
    // {
    //   title:
    //     'Plugs and cords are crossing an area of the room with high traffic.',
    //   icon1: '/static/svgs/living-room/extension-cords.svg',
    //   answers: [
    //     'Tape extension cords to the floor so that they don’t move around in the room.',
    //   ],
    //   correctAnswerIndex: 1,
    //   position: {
    //     x: 0.14,
    //     y: 0.2,
    //     z: 0.8
    //   },
    //   completed: false
    // },
    // {
    //   title: 'Blind cords are too long, puddling on the ground.',
    //   icon1: '/static/svgs/living-room/long-curtains.svg',
    //   answers: [
    //     'Remove blinds.',
    //   ],
    //   correctAnswerIndex: 1,
    //   position: {
    //     x: 1,
    //     y: 0.2,
    //     z: 0.2
    //   },
    //   completed: false
    // },
    {
      title:
        'Smoke from the unscreened wood-burning fireplace is billowing into the room.',
      icon1: '/static/svgs/living-room/den-tv-room.svg',
      answers: [
        'Install storm shutters ahead of time to protect vulnerable windows. If a storm is approaching, temporary plywood shutters will work in a pinch.',
      ],
      correctAnswerIndex: 2,
      position: {
        x: 0,
        y: 0.2,
        z: 1.1
      },
      completed: false
    }
  ]
};



// WEBPACK FOOTER //
// ./src/assets/questionsData/residential/firstFloor/LivingRoom.js